import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useAuthentication } from 'hooks/useAuthentication'

export const LogoutPage = () => {
  const { logout } = useAuthentication()
  const history = useHistory()

  useEffect(() => {
    logout()
    history.push('/login')
  }, [logout, history])

  return null
}
